<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "VrstaSkupaBase"
};
</script>

<style scoped>

</style>
